import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";

import financieelApi from "../../../api/financieelApi";

import { getStore } from "../../../store/configureStore";

export default class InvesteringenPageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.context.setState({
			investeringen: null,
			modalIsOpen: false,
			investeringId: null
		});

		const dossierId = this.context.props.dossierId;
		this.getInvesteringenByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	getInvesteringenByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getInvesteringenByDossierId(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadBeads(response.data.beadModels);
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	isReadyToRender() {
		if (!this.context.state.investeringen) {
			return false;
		}

		if (this.context.props.hoofdCategorien.length < 1) {
			return false;
		}

		if (this.context.props.typesInvestering.length < 1) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(item) {
		this.context.setState({
			investeringen: item
		});
	}

	deleteOpbrengstKostInvestering() {
		this.closeModal();
		this.dispatch(ajax.started());
		const state = this.context.state;
		const id = state.investeringId;
		financieelApi.deleteInvestering(id)
			.then(response => {
				let infrastructuren = this.context.state.investeringen.infrastructuren;
				let newInfrastructuren = infrastructuren.map((infrastructuur) => {
					return Object.assign({},
						infrastructuur,
						{
							investeringen: infrastructuur.investeringen ? infrastructuur.investeringen.filter(k => k.id !== id) : null
						});
				});
				let investeringen = this.context.state.investeringen;
				let newInvesteringen = Object.assign({},
					investeringen,
					{
						infrastructuren: newInfrastructuren
					});
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(newInvesteringen);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	closeModal() {
		this.context.setState({
			modalIsOpen: false
		});
	}

	openModal(id) {
		this.context.setState({
			modalIsOpen: true,
			investeringId: id
		});
	}

	goToInvesteringEdit() {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/investeringedit/new`);
	}

	goToInvesteringEditWijzig(id) {
		this.redirector.goTo(`financieel/${this.context.props.dossierId}/investeringedit/${id}`);
	}
}